var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export var debounce = function (callback, wait) {
    var timeout = undefined;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var next = function () { return callback.apply(void 0, __spreadArray([], __read(args), false)); };
        clearTimeout(timeout);
        timeout = window.setTimeout(next, wait);
    };
};
export var camelToSnakeCase = function (str) {
    return str ? str.replace(/[A-Z]/g, function (letter) { return "_" + letter.toLowerCase(); }) : '';
};
export var trailingSlash = function (str) { return (str.endsWith('/') ? str : str + '/'); };
export var convertBytes = function (bytes, size) {
    var base = 1024;
    var sizeExponents = {
        bytes: 0,
        kb: 1,
        mb: 2,
        tb: 3,
    };
    var exponentSize = sizeExponents[size];
    var exponent = exponentSize || 0;
    return Number((bytes / Math.pow(base, exponent)).toFixed(1));
};
export var mergeIntervals = function (intervals) {
    var e_1, _a;
    if (intervals.length === 0 || intervals.length === 1)
        return intervals;
    var sortedIntervals = __spreadArray([], __read(intervals), false).sort(function (a, b) {
        return a[0] - b[0];
    });
    var result = [sortedIntervals[0]];
    try {
        for (var sortedIntervals_1 = __values(sortedIntervals), sortedIntervals_1_1 = sortedIntervals_1.next(); !sortedIntervals_1_1.done; sortedIntervals_1_1 = sortedIntervals_1.next()) {
            var interval = sortedIntervals_1_1.value;
            var recentInterval = result[result.length - 1];
            if (recentInterval[1] >= interval[0]) {
                recentInterval[1] = Math.max(recentInterval[1], interval[1]);
            }
            else {
                result.push(interval);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (sortedIntervals_1_1 && !sortedIntervals_1_1.done && (_a = sortedIntervals_1.return)) _a.call(sortedIntervals_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return result;
};
//# sourceMappingURL=index.js.map